import { MdOutlineInventory2 } from "react-icons/md";
import {
    LuFactory,
    LuPackagePlus,
    LuPackageMinus,
    LuScale,
    LuEgg,
} from "react-icons/lu";
import { StockData, StockHistory } from "@/pages/stocks";
import { StockHistoryData } from "@/pages/stock-history";
import {
    StockInitialData,
    StockInitialCreate,
    StockInitialEdit,
} from "@/pages/stock-initial";
import { StockOutData, StockOutCreate, StockOutEdit } from "@/pages/stock-out";
import {
    StockAdjustmentData,
    StockAdjustmentCreate,
    StockAdjustmentEdit,
} from "@/pages/stock-adjustment";
import {
    ProductionData,
    ProductionCreate,
    ProductionEdit,
} from "@/pages/productions";
import {
    EggConversionData,
    EggConversionCreate,
    EggConversionEdit,
} from "@/pages/egg-conversion";

export const inventoryRoutes = {
    title: "PENYIMPANAN",
    type: "section",
    items: [
        {
            path: "/stocks",
            title: "Stok Gudang",
            icon: <MdOutlineInventory2 />,
            children: [
                {
                    path: "/stocks",
                    title: "Daftar Stok",
                    permission: "stock.view",
                    component: <StockData />,
                },
                {
                    path: "/stocks/history/warehouse/:warehouseId/material/:materialId/unit/:unitId",
                    title: "Riwayat Stok",
                    component: <StockHistory />,
                    permission: "stock.view",
                    type: "hidden",
                },
                {
                    path: "/stock-history",
                    title: "Riwayat Transaksi",
                    permission: "stock.view",
                    component: <StockHistoryData />,
                },
            ],
        },
        {
            path: "/stock-initial",
            title: "Stok Awal",
            icon: <LuPackagePlus />,
            permission: "stock-initial.view",
            component: <StockInitialData />,
            children: [
                {
                    path: "/stock-initial/create",
                    title: "Tambah Stok Awal",
                    component: <StockInitialCreate />,
                    permission: "stock-initial.create",
                    type: "hidden",
                },
                {
                    path: "/stock-initial/edit/:id",
                    title: "Edit Stok Awal",
                    component: <StockInitialEdit />,
                    permission: "stock-initial.edit",
                    type: "hidden",
                },
            ],
        },
        {
            path: "/stock-out",
            title: "Stok Keluar",
            icon: <LuPackageMinus />,
            permission: "stock-out.view",
            component: <StockOutData />,
            children: [
                {
                    path: "/stock-out/create",
                    title: "Tambah Stok Keluar",
                    component: <StockOutCreate />,
                    permission: "stock-out.create",
                    type: "hidden",
                },
                {
                    path: "/stock-out/edit/:id",
                    title: "Edit Stok Keluar",
                    component: <StockOutEdit />,
                    permission: "stock-out.edit",
                    type: "hidden",
                },
            ],
        },
        {
            path: "/stock-adjustment",
            title: "Penyesuaian Stok",
            icon: <LuScale />,
            permission: "stock-adjustment.view",
            component: <StockAdjustmentData />,
            children: [
                {
                    path: "/stock-adjustment/create",
                    title: "Tambah Penyesuaian Stok",
                    component: <StockAdjustmentCreate />,
                    permission: "stock-adjustment.create",
                    type: "hidden",
                },
                {
                    path: "/stock-adjustment/:batchId/edit",
                    title: "Edit Penyesuaian Stok",
                    component: <StockAdjustmentEdit />,
                    permission: "stock-adjustment.edit",
                    type: "hidden",
                },
            ],
        },
        {
            path: "/egg-conversion",
            title: "Konversi Telur",
            icon: <LuEgg />,
            permission: "egg-conversion.view",
            component: <EggConversionData />,
            children: [
                {
                    path: "/egg-conversion/create",
                    title: "Tambah Konversi Telur",
                    component: <EggConversionCreate />,
                    permission: "egg-conversion.create",
                    type: "hidden",
                },
                {
                    path: "/egg-conversion/:batchId/edit",
                    title: "Edit Konversi Telur",
                    component: <EggConversionEdit />,
                    permission: "egg-conversion.edit",
                    type: "hidden",
                },
            ],
        },
        {
            path: "/productions",
            title: "Produksi",
            icon: <LuFactory />,
            permission: "material-production.view",
            children: [
                {
                    path: "/productions/data",
                    title: "Riwayat Produksi",
                    component: <ProductionData />,
                },
                {
                    path: "/productions/create",
                    title: "Buat Produksi",
                    component: <ProductionCreate />,
                    permission: "material-production.create",
                    type: "hidden",
                },
                {
                    path: "/productions/:id/edit",
                    title: "Edit Produksi",
                    component: <ProductionEdit />,
                    permission: "material-production.edit",
                    type: "hidden",
                },
            ],
        },
    ],
};
